import type { ReactElement } from 'react';
import { useState, useEffect, useCallback, useRef } from 'react';
type Props = {
  children: (handler: () => void, isActive: boolean) => ReactElement;
  isActive?: boolean;
  onToggle?: (arg0: boolean) => void;
};
export function Toggler({ children, isActive: isActiveProp = false, onToggle }: Props) {
  const [isActive, setIsActive] = useState(isActiveProp);
  const prevIsActiveProp = useRef(isActiveProp);

  useEffect(() => {
    if (isActiveProp !== prevIsActiveProp.current) {
      setIsActive(isActiveProp);
    }
    prevIsActiveProp.current = isActiveProp;
  }, [isActiveProp]);

  const toggle = useCallback(() => {
    setIsActive((prev) => {
      const next = !prev;
      if (onToggle) {
        onToggle(next);
      }
      return next;
    });
  }, [onToggle]);

  return children(toggle, isActive);
}
